/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import BackgroundLayers from '../racing/BackgroundLayers';
import Coin from '../racing/Coin';
import EffectSprite from '../racing/EffectSprite';
import Hud from '../racing/Hud';
import OilSlick from '../racing/OilSlick';
import OtherCar from '../racing/OtherCar';
import PlayerCar from '../racing/PlayerCar';
import StartLight from '../racing/StartLight';
import RaceBanner from '../ui/RaceBanner';
import SpritePool from './SpritePool';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  preload() {
    // preload your assets here, if needed
    this.anims.create({ key: 'glowAnim', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { prefix: 'glow_', start: 2, end: 44 }) });
    this.anims.create({ key: 'smokeAnim', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { prefix: 'smoke1_', start: 1, end: 9 }) });
    this.anims.create({ key: 'explosion1Anim', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { prefix: 'explosion_', start: 0, end: 14 }), frameRate: 60 });
    this.anims.create({ key: 'explosion2Anim', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { prefix: 'explosion2_', start: 0, end: 17 }), frameRate: 60 });
    this.anims.create({ key: 'explosion3Anim', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { prefix: 'explosion3_', start: 0, end: 24 }), frameRate: 60 });
  }

  create() {
    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.engineSound = ABCyaPhaser.Audio.createSound(this);
    this.engineIdleSound = ABCyaPhaser.Audio.createSound(this);

    this.playerSpeed = 0;
    this.centerX = 0;
    this.curX = 0;
    this.lastX = 0;
    this.coinWaiter = 0;
    this.coinWaitTime = 12000;
    this.oilslickWaiter = 0;
    this.oilWaitTime = 100;
    this.maxTraffic = 8;
    this.livesLeft = 3;
    this.score = 0;
    this.isRacing = false;
    this.isGameOver = false;
    this.maxSpeed = 400;
    this.openLanes = [0, 1, 2, 3, 4, 5, 6, 7];
    this.coinType = gameData.coinmode;
    this.laneLocs = [188, 283, 378, 464, 570, 660, 750, 840];// [570, 660, 750, 840];
    this.maxTraffic = 8;
    this.activeTraffic = [];
    this.trafficWaiter = 2;
    this.activeCoins = [];
    this.coinWaitTime = 1.2;
    this.activeOilSlicks = [];
    this.oilWaitTime = 8.1;
    this.activeGlows = [];
    this.speeding = false;

    this.background = new BackgroundLayers(this);

    this.oilContainer = this.add.container();
    this.oilPool = new SpritePool(OilSlick, 10, this);

    this.coinContainer = this.add.container();
    this.coinPool = new SpritePool(Coin, 10, this);

    this.glowPool = new SpritePool(EffectSprite, 100, this);

    this.playerCar = new PlayerCar(this, this.mid.x, this.mid.y * 2 - 140);

    this.trafficPool = new SpritePool(OtherCar, this.maxTraffic, this);

    this.hud = new Hud(this, this.coinType);

    if (gameData.queueBusy) {
      // We aren't ready to start the game yet
      gameData.queueCompleteHandler = this.readySetGo.bind(this);
    }
    else {
      this.readySetGo();
    }
  }

  readySetGo() {
    ABCyaPhaser.Audio.playSound('player_car_engine', this.engineIdleSound, .5, true);

    this.startLight = new StartLight(this);
    this.startLight.once('GO_START', () => { this.beginRacing(); });
    this.startLight.once('GO_FINISH', () => { this.destroyStartLight(); });
    this.startLight.scale = 0;
    this.startLight.alpha = 0;
    this.dotPop(this.startLight, 500);

    this.startLight.x = this.mid.x - this.startLight.workingWidth / 2 + 10;
    this.startLight.y = this.mid.y - 80;
    this.startLight.doCountdown();
  };

  destroyStartLight() {
    this.startLight.removeAll(true);
    this.startLight.destroy();
    this.startLight = null;
  };

  beginRacing() {
    this.isRacing = true;
    this.downListener = this.input.on('pointerdown', (pointer) => { this.onClickGas(pointer); });
    this.moveListener = this.input.on('pointermove', (pointer) => { this.onSteer(pointer); });
    this.upListener = this.input.on('pointerup', (pointer) => { this.onReleaseGas(pointer); });

    this.children.bringToTop(this.playerCar);
  };

  // region ***** Player Movement ******
  onClickGas(pointer) {
    if (this.isGameOver) return;
    this.speeding = true;

    this.centerX = pointer.x;
    this.curX = this.centerX;
    this.playerSpeed = this.maxSpeed;
    this.background.updateSpeed(this.playerSpeed);
    this.playerCar.setPos(this.playerCar.x, this.playerCar.y);

    if (this.engineIdleSound) {
      this.engineIdleSound.stop();
    }
    if (this.engineSound) this.engineSound.stop();
    ABCyaPhaser.Audio.playSound('player_car_engine2', this.engineSound, .5, true);
  };

  onReleaseGas() {
    this.speeding = false;

    this.playerSpeed = 42;
    this.background.updateSpeed(this.playerSpeed);
    if (this.engineSound) this.engineSound.stop();
    if (!this.engineIdleSound) {
      ABCyaPhaser.Audio.playSound('player_car_engine', this.engineIdleSound, .5, true);
    }
    else {
      this.engineIdleSound.stop();
      ABCyaPhaser.Audio.playSound('player_car_engine', this.engineSound, .5, true);
    }
  };

  onSteer(pointer) {
    if (this.isGameOver || !this.speeding) return;
    if (this.playerCar.isResetting) {
      this.centerX = pointer.x;
      this.curX = this.centerX;
      return;
    }
    this.curX = pointer.x;
    const dif = this.centerX - this.curX;

    this.playerCar.steer(dif);
  };

  // endregion ****** End player movement ******


  // region ****** Traffic ******
  makeOtherCar() {
    const item = this.trafficPool.getSprite();
    if (!item) return; // Too many cars going already;

    const openLen = this.openLanes.length - 1;
    const laneIndex = Phaser.Math.Between(0, openLen);
    const laneNum = this.openLanes[laneIndex];
    this.openLanes.splice(laneIndex, 1);
    const startX = this.laneLocs[laneNum];
    const destX = startX;
    let startY = 0;
    const destY = 0;

    let spritename = '';
    let accelerationType = 1;
    if (Phaser.Math.Between(0, 100) > 50) {
      // Truck
      spritename = `Truck${Phaser.Math.Between(1, 3)}`;
    }
    else {
      // Car
      const carnum = Phaser.Math.Between(1, 5);
      spritename = `Car${carnum}`;
      if (carnum < 4 && Phaser.Math.Between(0, 100) > 68) {
        accelerationType = 2;
        startY = this.mid.y * 2;
      }
    }
    const speed = Phaser.Math.Between(260, 360);

    item.reset(spritename, accelerationType, laneNum, startX, destX, startY, destY, -speed);
    item.laneNum = laneNum;
    this.children.moveAbove(item, this.oilContainer);
    this.activeTraffic.push(item);
  };

  returnOtherCar(i) {
    this.openLanes.push(this.activeTraffic[i].laneNum);
    this.trafficPool.returnSprite(this.activeTraffic[i]);
    this.activeTraffic.splice(i, 1);
  };

  // endregion

  // region COINS 
  spawnCoin() {
    const item = this.coinPool.getSprite();
    if (item === null) return false;

    let num = Phaser.Math.Between(1, 9);
    const startX = this.laneLocs[Phaser.Math.Between(0, this.laneLocs.length - 1)] + 6;
    const startY = -10;
    let isgood = false;
    let sn = null;
    if (num % 2 === 0) {
      isgood = this.coinType === 'even';
      sn = 'coin';
    }
    else {
      isgood = this.coinType === 'odd';
      sn = 'coin_silver';
    }
    if (sn && gameData.GAME_TYPE === 'jr') num = sn;
    item.reset(num, isgood, startX, startY);

    this.activeCoins.push(item);
  };

  returnCoin(i) {
    this.coinPool.returnSprite(this.activeCoins[i]);
    this.activeCoins.splice(i, 1);
  };

  // endregion

  spawnEffect(x, y, type) {
    const item = this.glowPool.getSprite();
    if (item === null) return false;
    item.reset(x, y, type);
    item.once('animationcomplete', () => { this.returnEffect(item); });

    this.activeGlows.push(item);
  };

  returnEffect(target) {
    const e = target;
    const i = this.activeGlows.indexOf(e);

    this.glowPool.returnSprite(e);
    this.activeGlows.splice(i, 1);
  };

  // region OIL SLICKS
  spawnOilSlick() {
    const item = this.oilPool.getSprite();
    if (item === null) return false;
    const startX = this.laneLocs[Phaser.Math.Between(0, this.laneLocs.length - 1)];
    const startY = -10;
    item.reset(startX, startY);

    this.children.moveAbove(item, this.background);

    this.activeOilSlicks.push(item);
  };

  returnOilSlick(i) {
    this.oilPool.returnSprite(this.activeOilSlicks[i]);
    this.activeOilSlicks.splice(i, 1);
  };

  // endregion

  // region **** Collision *****
  checkRectHit(a, b) {
    return a.left <= b.right &&
      b.left <= a.right &&
      a.top <= b.bottom &&
      b.top <= a.bottom;
  };

  // endregion

  doGameOver() {
    this.isGameOver = true;
    this.onReleaseGas();
    if (this.engineSound) this.engineSound.stop();
    if (this.engineIdleSound) this.engineIdleSound.stop();

    this.finishedDialog = new RaceBanner(this);
    this.finishedDialog.scale = 0;
    this.finishedDialog.alpha = 0;
    this.dotPop(this.finishedDialog, 660);
    this.finishedDialog.x = this.mid.x;
    this.finishedDialog.y = this.mid.y;

    this.time.delayedCall(2500, () => { this.showResults(); });
  };

  showResults() {
    gameData.coinScore = this.score;
    this.engineSound.destroy();
    this.engineIdleSound.destroy();
    this.engineSound = null;
    this.engineIdleSound = null;
    this.scene.start('Results');
  };

  update(e, t) {
    if (!this.isRacing) return;
    if (this.trafficWaiter < 0) {
      this.makeOtherCar();
      this.trafficWaiter = Phaser.Math.Between(9, 16) / 10;
    }
    else {
      this.trafficWaiter -= t / 1000;
    }

    this.background.update(t);
    if (!this.isGameOver) this.playerCar.update(t);

    let len = this.activeTraffic.length - 1;
    const trackSpeedMod = this.background.curSpeed / this.maxSpeed;
    for (let i = len; i >= 0; i--) {
      const car = this.activeTraffic[i];
      car.update(t, trackSpeedMod);
      if (car.timeOffscreen > 3) {
        this.returnOtherCar(i);
      }
      if (!this.playerCar.isResetting) {
        // Check collision with player
        if (this.checkRectHit(this.playerCar.boundries, car.boundries)) {
          let dir = -1;
          if (this.playerCar.x < car.x) {
            dir = 1;
          }
          car.doCrash(dir);
          this.spawnEffect(car.x, car.y, 'explosion3');
          const soundnum = Phaser.Math.Between(1, 11);
          ABCyaPhaser.Audio.playOneShot(`car_impacts_${soundnum}`, this);
          this.playerCar.hitTraffic();
          this.centerX = this.input.pointer1.x;
          this.curX = this.centerX;
          this.playerCar.setPos(this.playerCar.x, this.playerCar.y);
          this.livesLeft--;
          if (this.livesLeft > 0) {
            this.hud.helmetCrash(this.livesLeft);
          }
          else {
            this.hud.helmetCrash(this.livesLeft);
            this.doGameOver();
          }
        }
      }
    }

    // Collision checks
    len = this.activeCoins.length - 1;
    for (let i = len; i >= 0; i--) {
      const coin = this.activeCoins[i];
      if (coin.isActive) coin.update(t, this.background.curSpeed);
      if (coin.y > this.mid.y * 2 || !coin.isAlive) {
        this.returnCoin(i);
      }
      else {
        if (coin.isActive && this.checkRectHit(this.playerCar.boundries, coin.boundries)) {
          coin.collected();
          if (coin.isGood) {
            this.score++;
            this.spawnEffect(coin.x, coin.y, 'glow');
            ABCyaPhaser.Audio.playOneShot('bling', this);
          }
          else {
            if (this.score > 0) this.score--;
            ABCyaPhaser.Audio.playOneShot('crash', this);
            this.spawnEffect(coin.x, coin.y, 'explosion2');
          }
          this.hud.updateScore(this.score);
        }
      }
    }

    len = this.activeOilSlicks.length - 1;
    for (let i = len; i >= 0; i--) {
      const slick = this.activeOilSlicks[i];
      slick.update(t, this.background.curSpeed);
      if (slick.y > this.mid.y * 2) {
        this.returnOilSlick(i);
      }
      else {
        if (!slick.beenHit && this.checkRectHit(this.playerCar.boundries, slick.boundries)) {
          ABCyaPhaser.Audio.playOneShot('squeal', this);
          slick.beenHit = true;
          this.playerCar.hitOil();
        }
      }
    }

    if (this.coinWaiter < 0) {
      this.spawnCoin();
      this.coinWaiter = Phaser.Math.Between(2, 12) / 10;
    }
    else {
      if (trackSpeedMod > 0) this.coinWaiter -= t / 1000;
    }

    if (this.oilslickWaiter < 0) {
      this.spawnOilSlick();
      this.oilslickWaiter = Phaser.Math.Between(2, 12);
    }
    else {
      if (trackSpeedMod > 0) this.oilslickWaiter -= t / 1000;
    }
  };

  dotPop(obj, time = 320, wait = 0) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scale: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  };
}